<mh-dashboard-widget-card [ready]="ready()">
  <mh-chart-value-widget
    title="NPS"
    [subtitle]="subtitle"
    [description]="npsData()?.descriptionKey | translate"
    [product]="product"
    [enabled]="enabled()"
    [value]="displayValue()"
    [loading]="loading()"
    [error]="error()"
    [changePercentage]="displayChange()"
    [increase]="isIncrease()"
    [route]="route"
    [demoRoute]="demoRoute"
    [chartData]="chartData()"
    [chartOptions]="npsChartOptions"
    [gaKey]="gaKey"
  />
</mh-dashboard-widget-card>
